import { paymentApi } from './paymentApi';

export const surveyLimitService = {
  // Check if a user can create a new survey based on the new requirements
  canCreateSurvey: async (userData, auth) => {
    const { isAdmin, credits } = auth;
    
    // Admins can always create surveys
    if (isAdmin) return { canCreate: true };
    
    // Get user attributes from Cognito
    const userDetails = await paymentApi.getUserDetails();
    const lastUsedDate = userDetails.lastUsedApp ? new Date(userDetails.lastUsedApp) : null;
    const subscriptionUntil = userDetails.subscriptionUntil ? new Date(userDetails.subscriptionUntil) : null;
    const currentDate = new Date();
    const hasSubscription = subscriptionUntil && subscriptionUntil > currentDate;
    
    // Has subscription and at least 1 credit
    if (hasSubscription && credits > 0) {
      return { canCreate: true };
    }
    
    // No subscription, but has credits and last used date > 5 minutes ago
    if (!hasSubscription && credits > 0) {
      // If no last used date, they can create
      if (!lastUsedDate) {
        return { canCreate: true };
      }
      
      // Calculate minutes since last use
      const minutesSinceLastUse = Math.floor((currentDate - lastUsedDate) / (1000 * 60));
      
      if (minutesSinceLastUse > 5) {
        return { canCreate: true };
      } else {
        return {
          canCreate: false,
          message: 'Please wait at least 5 minutes between research creations.'
        };
      }
    }
    
    // Not eligible - no credits
    return {
      canCreate: false,
      message: 'Please sign up to our beta to get unrestricted access to our platform'
    };
  },
  
  // Update last used app date when survey is generated
  updateLastUsedDate: async () => {
    try {
      const currentDate = new Date().toISOString();
      await paymentApi.updateUserAttributes({
        'custom:last_used_app': currentDate,
        'custom:last_free_research': currentDate
      });
    } catch (error) {
      console.error('Failed to update last used date:', error);
    }
  },

};